import api, { authService } from './api';

export const permissionService = {
  listAll: async () => {
    try {
      const token = authService.getToken();
      if (!token) throw new Error('No authentication token');

      const response = await api.get('/permissions/table-permissions', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return {
        success: true,
        permissions: response.data || [],
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.detail || 'Failed to fetch table permissions',
      };
    }
  },

  create: async (payload) => {
    try {
      const token = authService.getToken();
      if (!token) throw new Error('No authentication token');

      const response = await api.post('/permissions/table-permissions', payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return {
        success: true,
        permission: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.detail || 'Failed to create table permission',
      };
    }
  },

  update: async (permissionId, payload) => {
    try {
      const token = authService.getToken();
      if (!token) throw new Error('No authentication token');

      const response = await api.patch(`/permissions/table-permissions/${permissionId}`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return {
        success: true,
        permission: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.detail || 'Failed to update table permission',
      };
    }
  },

  delete: async (permissionId) => {
    try {
      const token = authService.getToken();
      if (!token) throw new Error('No authentication token');

      const response = await api.delete(`/permissions/table-permissions/${permissionId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return {
        success: true,
        message: response.data.message,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.detail || 'Failed to delete table permission',
      };
    }
  },
  getCurrentUser: async () => {
    try {
      const token = authService.getToken();
      if (!token) throw new Error('No authentication token');

      const response = await api.get('/permissions/me', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return {
        success: true,
        permissions: response.data.table_permissions || [],
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.detail || 'Failed to fetch current user permissions',
      };
    }
  },
};
